import { Directive, ElementRef, Input, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';

@Directive({
  selector: '[hasPermission]'
})
export class AccessControlDirective {

  @Input('hasPermission') permissions :any =[]
  @Input('hasPermission') op!: string;
  logicalop !:string
  constructor(private el: ElementRef,
    private templateRef: TemplateRef<any>,private viewContainer: ViewContainerRef) {}

  ngOnInit() { }


  @Input()
  set hasPermission(val:any) {
    this.permissions = val;
  }

  private updateView() {
    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  @Input()
  set hasPermissionOp(permop:any) {
    this.logicalop = permop;
    this.updateView();
  }

  private checkPermission() {
    let hasPermission;
     if(this.permissions && this.permissions.indexOf(this.logicalop) >= 0){
      hasPermission = true
     } else  {
      hasPermission = false
     }
     return hasPermission;

  }

}
